<p-dialog
    id="dashboard-new-inquiry-modal"
    styleClass="dashboard-new-inquiry-modal"
    pAutoFocus
    [autofocus]="true"
    [draggable]="false"
    [visible]="isVisible()"
    [modal]="true"
    [closable]="false"
    [resizable]="false"
    appendTo="body">
    <ng-template pTemplate="header">
        <div id="dashboard-new-inquiry-modal-header">
            <h1>{{ 'dashboard.templatesAndForm.requestQuoteForCustomWorkModal.title' | translate }}</h1>

            <p-button
                id="close-modal-btn"
                icon="fa-regular fa-xmark"
                [rounded]="true"
                [severity]="'secondary'"
                [text]="true"
                (onClick)="onCloseModal()"></p-button>
        </div>
    </ng-template>

    <ng-template pTemplate="content">
        <div id="dashboard-new-inquiry-modal-content">
            <p>
                <b>
                    <i>{{ 'dashboard.templatesAndForm.requestQuoteForCustomWorkModal.info' | translate }}</i></b
                >
            </p>

            <div class="field-container">
                <label id="description-field-label" for="description-field-input">
                    {{ 'group.settings.generalSettings.description' | translate }} <span class="p-error">*</span>
                </label>
                <textarea
                    id="request-custom-work-message"
                    rows="6"
                    pInputTextarea
                    #descriptionField="ngModel"
                    [maxlength]="descriptionMaxLength"
                    [minlength]="descriptionMinLength"
                    [placeholder]="
                        'dashboard.templatesAndForm.requestQuoteForCustomWorkModal.description.placeholder' | translate
                    "
                    [(ngModel)]="description"
                    [placeholder]="'group.settings.generalSettings.description.placeholder' | translate">
                </textarea>

                <div class="error-counter-container">
                    @if (
                        (descriptionField.touched || descriptionField.dirty) && descriptionField?.errors?.['minlength']
                    ) {
                        <p class="error-text">
                            {{
                                ('group.settings.generalSettings.description' | translate) +
                                    ' ' +
                                    ('minLengthFormValidator' | translate: { limit: descriptionMinLength })
                            }}
                        </p>
                    }
                    <app-character-counter
                        [text]="description()"
                        [maxLength]="descriptionMaxLength"
                        [placement]="'right'">
                    </app-character-counter>
                </div>
            </div>
        </div>
    </ng-template>

    <ng-template pTemplate="footer">
        <p-button
            id="cancel-btn"
            [outlined]="true"
            [disabled]="isLoading()"
            [severity]="'secondary'"
            (onClick)="onCloseModal()"
            >{{ 'cancel' | translate }}</p-button
        >
        <p-button
            id="submit-inquiry-btn"
            [loading]="isLoading()"
            [disabled]="
                isLoading() ||
                description() === '' ||
                description().trim() === '' ||
                description().length < descriptionMinLength
            "
            (click)="onSubmitInquiry()"
            >{{ 'dashboard.templatesAndForm.requestQuoteForCustomWorkModal.submitBtn' | translate }}</p-button
        >
    </ng-template>
</p-dialog>
